export default __webpack_public_path__ + "static/media/failedIco.08a985f6.svg";